export class UserStaffInfo {
    public Active: boolean = true;
    public BasysID: string = '';
    public BlockedClients: Array<string> = [];
    public Department: string = '';
    public DisplayName: string = '';
    public GivenName: string = '';
    public ImageURL: string = '';
    public InternetOutAccount: Array<string> = [];
    public MaintainStaffOnServer: Array<string> = [];
    public MaintainTags: boolean = false;
    public MobileEditing: string = '';
    public Notes: string = '';
    public PhysicalLocation: string = '';
    public Program: string = '';
    public ServerManager: boolean = false;
    public SmartPhoneTSVEditing: string = '';
    public Snapfeed: boolean = false;
    public Supervisor: boolean = false;
    public Surname: string = '';
    public UserID: string = '';
    public VID: string = '';
    public WebEditing: string = '';
    public Name: string = '';
    public Email: string = '';
    public SSOLogins: string = '';
    public InvitationStatus: string = '';
    public GlobalRole: string = '';
    public Title: string = '';
    public Phone: string = '';

    public getAs<T>(field: string, defaultValue?: T): T {
        // Typed get
        if (!this[field] || typeof this[field] === 'undefined') {
            this[field] = defaultValue;
        }
        return this[field];
    }

    public get(field: string, defaultValue?: any): any {
        return this.getAs<any>(field, defaultValue);
    }
}
